import React from 'react';
import { TYPE_PLAYLIST_THUMBNAIL, TYPE_ASSET_THUMBNAIL, TYPE_TOPIC_THUMBNAIL } from 'utils/file';
import { AssetThumbnailPreview, PlaylistThumbnailPreview, TopicThumbnailPreview } from 'screens/ThumbnailPreview';
import { jsx as _jsx } from "react/jsx-runtime";
var ImagePreviewModal = function ImagePreviewModal(_ref) {
  var _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    content = _ref.content,
    fileType = _ref.fileType,
    previewUrl = _ref.previewUrl,
    onClose = _ref.onClose,
    onReset = _ref.onReset,
    onUpload = _ref.onUpload,
    onReplace = _ref.onReplace;
  if (fileType === TYPE_PLAYLIST_THUMBNAIL && onReplace && onUpload && onReset) {
    return /*#__PURE__*/_jsx(PlaylistThumbnailPreview, {
      isDisabled: isDisabled,
      data: content,
      previewUrl: previewUrl,
      onClose: onClose,
      onReset: onReset,
      onUpload: onUpload,
      onReplace: onReplace
    });
  } else if (fileType === TYPE_ASSET_THUMBNAIL) {
    return /*#__PURE__*/_jsx(AssetThumbnailPreview, {
      data: content,
      onClose: onClose
    });
  } else if (fileType === TYPE_TOPIC_THUMBNAIL) {
    return /*#__PURE__*/_jsx(TopicThumbnailPreview, {
      data: content,
      onClose: onClose
    });
  }
  return null;
};
export default ImagePreviewModal;